import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { useState } from "react";
import type { IAccountData } from "src/Types/account.types";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import AccountTableRow from "./AccountTableRow";
import CreateAccount from "./CreateAccount";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";

const AccountList = () => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const { data, isLoading } = useGetQueryWithTotal<IAccountData[]>({
		endPoint: "/api/fair/admin/account",
		queryKeys: ["Accounts"],
		params: { ...pagination },
	});

	// Modal
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	return (
		<CommCard
			showCardHeader
			headerTitle={`Account List (${data?.total || 0})`}
			helmetTitle='BTTF - Account list'
			showButton
			btnText='Create Account'
			handleBtnForModalFun={() => handleOpen()}
		>
			<Box>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Bank Name</TableCell>
								<TableCell>Account Name</TableCell>
								<TableCell>Account Type</TableCell>
								<TableCell>Account Number</TableCell>
								<TableCell>Branch name</TableCell>
								<TableCell>Balance</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : data?.data?.length > 0 ? (
							<TableBody>
								{data?.data?.map((account: IAccountData) => {
									const idx = data?.data?.indexOf(account);

									return (
										<AccountTableRow
											key={account.ac_id}
											account={account}
											serial={idx + 1}
										/>
									);
								})}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>
				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
				{/* Modal */}
				<Dialog
					fullScreen={fullScreen}
					open={open}
					maxWidth='md'
					onClose={handleClose}
					aria-labelledby='responsive-dialog-title'
				>
					<DialogContent>
						<Box sx={{ mb: 2 }}>
							<Typography sx={{ mb: 2 }}>
								Create Account
							</Typography>
						</Box>
						<CreateAccount handleClose={handleClose} />
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={handleClose}>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</Box>
		</CommCard>
	);
};

export default AccountList;
